import React from 'react'
import { Text, Grid, AspectRatio, VStack, CSSObject } from '@chakra-ui/react'
import Image from 'next/image'

export interface ServiceInfoProps {
  title: string
  paragraph: React.ReactNode
  image: string | StaticImageData
  sx?: CSSObject
}

function ServiceInfo({
  title,
  paragraph,
  image,
  sx,
}: ServiceInfoProps): React.ReactElement {
  return (
    <Grid
      layerStyle="container"
      sx={{
        borderBottom: '1px solid',
        borderColor: 'gray.300',
        gridGap: { base: 8, md: 0 },
        alignItems: 'center',
        gridTemplateColumns: {
          base: '1fr',
          md: '1fr 1fr',
        },
        gridAutoFlow: 'row dense',
        ...sx,
      }}
    >
      <AspectRatio
        ratio={667 / 613}
        sx={{
          mr: {
            base: 10,
            sm: 20,
            md: 20,
          },
          ml: {
            base: 10,
            sm: 20,
            md: 0,
          },
        }}
      >
        <Image
          src={image}
          alt=""
          layout="fill"
          objectFit="contain"
          placeholder="blur"
        />
      </AspectRatio>
      <VStack
        spacing={{
          base: 4,
          sm: 6,
        }}
        sx={{
          alignItems: { base: 'center', md: 'flex-start' },
        }}
      >
        <Text
          as="h3"
          sx={{
            fontSize: { base: '2xl', sm: '4xl' },
            flex: '1 1 auto',
            w: 'full',
            lineHeight: '1em',
            textAlign: { base: 'center', md: 'left' },
            fontWeight: 'medium',
          }}
        >
          {title}
        </Text>

        <Text
          as="h1"
          sx={{
            fontSize: { base: 'lg', sm: '2xl' },
            flex: '1 1 auto',
            w: 'full',
          }}
        >
          {paragraph}
        </Text>
      </VStack>
    </Grid>
  )
}

export default ServiceInfo
